import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { TranslatedString } from "@classdojo/web/pods/i18n/translate";
import { AT } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { useCallback, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { openSalesPage } from "src/pods/webviewInit";
import { logParentToolkitEvent } from "src/utils/logEvent";
import { IdeasLockIcon } from "./IdeasIcons";

type ToolkitListItemProps = {
  title?: TranslatedString;
  description?: string;
  pageUrl: string;
  color?: string;
  imgUrl?: string;
  isLocked?: boolean;
  loggingId?: string;
  size?: string;
  lockedUrl: string;
  background?: string;
  isNew?: boolean;
};

export default function ToolkitListItem(props: ToolkitListItemProps) {
  useEffect(() => {
    logParentToolkitEvent({ eventName: `${props.loggingId}${props.isLocked ? `_locked` : ``}.exposure` });
  }, [props.loggingId, props.isLocked]);

  const itemHeight = useMemo(() => (props.size === "large" ? 115 : 90), [props.size]);
  const descriptionSize = useMemo(() => (props.size === "large" ? 16 : 12), [props.size]);
  const textTop = useMemo(() => (props.size === "large" ? 18 : 12), [props.size]);
  const descriptionWeight = useMemo(() => (props.size === "large" ? 400 : 600), [props.size]);

  const onClick = useCallback(() => {
    logParentToolkitEvent({ eventName: `${props.loggingId}${props.isLocked ? `_locked` : ``}.tap` });
    if (props.isLocked) {
      openSalesPage();
    }
  }, [props.isLocked, props.loggingId]);

  return (
    // eslint-disable-next-line @web-monorepo/no-style-prop
    <Link to={props.isLocked ? props.lockedUrl : props.pageUrl} style={{ textDecoration: "none" }}>
      <div
        sx={{
          backgroundColor: RAW_cssValue(props.color),
          backgroundImage: props.background,
          width: "100%",
          minHeight: itemHeight,
          borderRadius: "dt_radius_s",
          maxWidth: 512,
          margin: RAW_cssValue("12px auto 12px"),
          display: "flex",
          flexDirection: "row",
        }}
        onClick={onClick}
      >
        <div
          sx={{
            flexGrow: 1,
            marginTop: RAW_cssValue(textTop),
            marginBottom: RAW_cssValue(textTop),
            marginLeft: RAW_cssValue(18),
          }}
        >
          {props.isNew && (
            <>
              <div
                sx={{
                  display: "inline-block",
                  fontWeight: "bold",
                  fontSize: 12,
                  lineHeight: "12px",
                  letterSpacing: "0.5px",
                  color: "dt_content_tertiary",
                  padding: RAW_cssValue("10px 12px"),
                  background: "#fff",
                  borderRadius: "dt_radius_m",
                  textTransform: "uppercase",
                  marginBottom: RAW_cssValue(6),
                }}
              >
                <AT>new</AT>
              </div>
              <br />
            </>
          )}
          {props.isLocked && (
            <div sx={{ display: "inline-block", verticalAlign: "middle", marginRight: RAW_cssValue(5) }}>
              <IdeasLockIcon color="dt_content_light" />
            </div>
          )}
          <div
            sx={{
              fontSize: 18,
              color: "dt_content_light",
              fontWeight: 800,
              overflowWrap: "break-word",
              display: "inline-block",
              verticalAlign: "middle",
            }}
          >
            {props.title}
          </div>
          <div
            sx={{
              fontSize: descriptionSize,
              fontWeight: descriptionWeight,
              color: "dt_content_light",
              overflowWrap: "break-word",
              lineHeight: 1.4,
            }}
          >
            {props.description}
          </div>
        </div>
        <img
          src={props.imgUrl}
          sx={{
            height: 72,
            width: 72,
            marginTop: RAW_cssValue("auto"),
            marginBottom: RAW_cssValue("auto"),
            marginRight: RAW_cssValue(18),
            marginLeft: RAW_cssValue(18),
          }}
        />
      </div>
    </Link>
  );
}
